import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";

export class SimpleTextProperty extends PropertyBase{
    public label:string="Label";


    public SubRenderer(): React.ReactNode {
        return (
            <RNTextInput Label={this.label} Value={this.GetOptionValue(this.OptionsPropertyName)}   onChange={e=>this.SetOptionValue(e,this.OptionsPropertyName)} disabled={this.disabled}/>
        )
    }

}